<template>
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>资金日报</span>
    </div>
    <div class="name">{{objData.tenantName}}</div>
    <div class="summary">
      <div class="summary-div">
        <div class="show-tis">
          <p class="p1 col1">
            {{ objData.yesterdayBalance ? objData.yesterdayBalance : "-" }}
          </p>
          <p class="p2">昨日结余汇总</p>
        </div>
        <div class="show-tis">
          <p class="p1 col2">{{ objData.todayIncome ? objData.todayIncome : "-" }}</p>
          <p class="p2">今日收入汇总</p>
        </div>
      </div>
      <div class="summary-div">
        <div class="show-tis">
          <p class="p1 col2">
            {{ objData.todayExpenditure ? objData.todayExpenditure : "-" }}
          </p>
          <p class="p2">今日支出汇总</p>
        </div>
        <div class="show-tis">
          <p class="p1 col2">{{ objData.todayBalance ? objData.todayBalance : "-" }}</p>
          <p class="p2">今日结余汇总</p>
        </div>
      </div>
    </div>
    <div class="list-box" v-if="objData.itemVoList != undefined && objData.itemVoList.length > 0">
      <ul class="ul-list" v-for="item in objData.itemVoList">
        <li>
          <span>银行账号</span>
          <em>{{item.accountName}}</em>
        </li>
        <li>
          <span>开户银行</span>
          <em>{{item.depositBankName}}</em>
        </li>
        <li>
          <span>银行网点</span>
          <em>{{item.bankPoint}}</em>
        </li>
        <li>
          <span>日期</span>
          <em>{{item.billDate}}</em>
        </li>
        <li>
          <span>昨日结余</span>
          <em>{{item.yesterdayBalance}}</em>
        </li>
        <li>
          <span>今日收入</span>
          <em>{{item.todayIncome}}</em>
        </li>
        <li>
          <span>今日支出</span>
          <em>{{item.todayExpenditure}}</em>
        </li>
        <li>
          <span>今日结余</span>
          <em>{{item.todayBalance}}</em>
        </li>
      </ul>
    </div>
    <div class="no-data" v-else>
        <img src="@/assets/propertyImg/no-data.png" />
        <span>暂无数据</span>
      </div>
  </div>
</template>
<script>
import { fundDaily } from "@/axios/financial";
export default {
  components: {},
  data() {
    return {
      objData: {},
    };
  },
  watch: {},
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    async getData() {
      let parms = {
      };
      const res = await fundDaily(parms);
      let resData = res.data.data;
      this.objData = resData;
    },
    backPage() {
      // 回退到app
      window.location.href = "jsToOc://back";
    },
  },
};
</script>
<style lang="less" scoped>
.head-navigate {
  position: sticky;
  top: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.3rem 0.3rem;
  border-bottom: 1px solid #f0f2f5;
}
/deep/.con {
  .van-tabs {
    .van-tabs__wrap {
      position: sticky;
      top: 49px;
      z-index: 99999;
    }
  }
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
.name {
  text-align: center;
  background: #fff;
  padding: 15px 10px;
}
.summary {
  background: #fff;
  overflow: hidden;
  padding: 15px;
  border-radius: 8px;
  margin: 10px;
  .summary-div {
    overflow: hidden;
    margin-bottom: 10px;
    .show-tis {
      float: left;
      width: 50%;
      text-align: center;
      p {
        margin: 0px;
      }
    }
  }
}
.p1 {
  font-size: 20px;
}
.p2 {
  font-size: 14px;
  color: #666;
}
.col1 {
  color: #1484ff;
}
.col2 {
  color: #ff6226;
}
.ul-list {
  background: #fff;
  overflow: hidden;
  padding: 15px 0px;
  border-radius: 8px;
  margin: 10px;
  li {
    overflow: hidden;
    border-bottom: solid 1px #f3f3f3;
    padding: 10px 15px;
    span {
      float: left;
      font-size: 16px;
      color: #333;
    }
    em {
      float: right;
      font-style: normal;
      font-size: 14px;
      color: #666;
    }
  }
  li:last-child {
    border-bottom: none;
  }
}
.list-box{
    padding-bottom: 30px;
}
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 0.3rem;
}
.no-data img {
  width: 5rem;
  height: 5rem;
  margin-bottom: 0.5rem;
}
.no-data span {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  font-size: 28rpx !important;
}
</style>
